export default __webpack_public_path__ + "static/media/hero-img.5d70da70.png";